// extracted by mini-css-extract-plugin
module.exports = {"wrap":"src-components-ticketTitle-__index__wrap--2NCQT","title":"src-components-ticketTitle-__index__title--1ryKz","border":"src-components-ticketTitle-__index__border--ofR4u"};